import { Avatar, Box, Chip, Grid, Stack, Typography } from '@mui/material';
import { useOutletContext, useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { GET_BRAND } from '@gql/brand';
import BrandAboutCard from './components/BrandAboutCard';
import BrandGeoLocationCard from './components/BrandGeoLocationCard';
import BrandPhotosCard from './components/BrandPhotosCard';
import BrandStatsCard from './components/BrandStatsCard';
import BrandVideosCard from './components/BrandVideosCard';

interface OutletContextType {
    searchParams: any;
    setSearchParams: (params: any) => void;
}

const BrandDetail = () => {
    const { id } = useParams<{ id: string }>();
    useOutletContext<OutletContextType>();

    const { data, loading, refetch } = useQuery(GET_BRAND, {
        variables: { id },
        skip: !id,
    });

    const brand = data?.getBrand;

    if (loading) {
        return (
            <Box sx={{ flex: 1, width: '100%' }}>
                <Typography color="textSecondary">Chargement...</Typography>
            </Box>
        );
    }

    if (!brand) {
        return (
            <Box sx={{ flex: 1, width: '100%' }}>
                <Typography color="textSecondary">Marque introuvable.</Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ flex: 1, width: '100%' }}>
            <Grid container spacing={3}>
                {/* Left column - Sidebar */}
                <Grid item xs={12} md={8}>
                    <Stack spacing={3}>
                        <BrandAboutCard brand={brand} onSuccess={refetch} />
                        <BrandPhotosCard brand={brand} />
                        <BrandVideosCard brand={brand} />
                    </Stack>
                </Grid>

                {/* Right column - Main content */}
                <Grid item xs={12} md={4}>
                    <Stack spacing={3}>
                        <BrandStatsCard brand={brand} />
                        <BrandGeoLocationCard brand={brand} onUpdated={refetch} />
                    </Stack>
                </Grid>
            </Grid>
        </Box>
    );
};

export default BrandDetail;
